import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793b28b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Sensor", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Valor", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Operador", -1))
const _hoisted_6 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SelectSensor = _resolveComponent("SelectSensor")!
  const _component_SelectComparator = _resolveComponent("SelectComparator")!
  const _component_SelectOperator = _resolveComponent("SelectOperator")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Adicionar Regra",
    isActive: _ctx.isActive,
    onCloseModalClick: _ctx.closeModal,
    size: "large"
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-clipboard" })
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_SelectSensor, {
          selectedSensor: _ctx.selectedSensor,
          onOnSelectSensor: _ctx.selectSensor
        }, null, 8, ["selectedSensor", "onOnSelectSensor"]),
        _createVNode(_component_SelectComparator, {
          selectedOption: _ctx.selectedComparator,
          onOnSelectOption: _ctx.selectComparator
        }, null, 8, ["selectedOption", "onOnSelectOption"]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleValue) = $event))
        }, null, 512), [
          [_vModelText, _ctx.ruleValue]
        ]),
        _createVNode(_component_SelectOperator, {
          selectedOption: _ctx.selectedOperator,
          onOnSelect: _ctx.selectOperator
        }, null, 8, ["selectedOption", "onOnSelect"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "button delete-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "Cancelar"),
        _createElementVNode("button", {
          class: "button save-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args)))
        }, "Confirmar")
      ])
    ]),
    _: 1
  }, 8, ["isActive", "onCloseModalClick"]))
}